export default __webpack_public_path__ + "static/media/lung_plot_female.7fc5dd2d.png";